/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import React from "react"
import { CustomerBreadcrumbs } from "./CustomerBreadcrumbs"
import { Spacer } from "@cd2/components"
import { H2 } from "@cd2/text"
import { brandColors } from "../../../Components/EOSThemeProvider"

export function PageTitle({
  title,
  actions,
  breadcrumbs,
}: {
  title: React.ReactNode
  actions?: React.ReactNode
  breadcrumbs?: { label: string; to: string }[]
}) {
  return (
    <React.Fragment>
      {breadcrumbs && breadcrumbs.length > 0 && (
        <div
          css={css`
            margin-bottom: 24px;
          `}
        >
          <CustomerBreadcrumbs breadcrumbs={breadcrumbs} />
        </div>
      )}
      <div
        css={css`
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 16px;
        `}
      >
        {typeof title === "string" ? (
          <H2 color={brandColors.darkNight} size="large">
            {title}
          </H2>
        ) : (
          title
        )}
        {actions}
      </div>
      <Spacer size={24} />
    </React.Fragment>
  )
}
